import { useContext } from 'react';

import { ConfigContext } from '@/@mantis/contexts/ConfigContext';

export default function useConfig() {
  return useContext(ConfigContext);
}
